import Footer from './Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import { useTranslation } from 'react-i18next';

export default function FooterDataprotection() {
    const { t } = useTranslation();
    
    return (

        <div className="container flexdiv">

            <LandingpageHeader />

            <article>

                <h3 style={{ textAlign: 'center' }}> {t('deTranslation.pageDataProtection.title')}</h3>

                
            </article>

            <Footer />
        </div>
    );
}
